import React from 'react'
import Posts from './Posts'
import classes from './Dashboard.module.css'
import { useAuth } from '../Context/AuthContext'
import FileUpload from './FileUpload'
import { auth } from '../firebaseConfig'
import ErrorLogin from './ErrorLogin'

function Dashboard() {
    const { loggedIn } = useAuth();
    return (
        <React.Fragment>
            {auth.currentUser && loggedIn ? < FileUpload /> : <ErrorLogin />}


            <div className={classes.dashboard}>

                <Posts collection={'images'} />
            </div>
        </React.Fragment>
    )
}

export default Dashboard
